export default __webpack_public_path__ + "static/media/pptx.96d248a5.svg";